const navigationSticky = document.querySelector('.navigation-to-section-sticky')
if (navigationSticky) {
    navigationSticky.classList.add('d-none')

    navigationSticky.addEventListener('click', function (event) {
        if (event.target.tagName === 'A') {
            const itemActived = event.currentTarget.querySelector('a.actived')
            itemActived.classList.remove('actived')
            event.target.classList.add('actived')
        }
    })

    if (window.matchMedia('(min-width:1200px').matches) {
        window.addEventListener('scroll', function () {
            if (window.scrollY >= 200) {
                navigationSticky.classList.remove('d-none')
            } else {
                navigationSticky.classList.add('d-none')
            }
        })
    }
}
